import React from 'react';
import { Icon, type IIconProps } from './Icon';

export const AngleDoubleUpIcon: React.FC<IIconProps> = (props) => (
  <Icon {...props}>
    <path
      /* eslint-disable max-len */
      d={
        'M270.6 73.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L248 141.3 385.4 278.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160zm160 352l-160-160c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L248 333.3 385.4 470.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z'
      }
      /* eslint-enable max-len */
    />
  </Icon>
);
